import Modal from 'components/shared/Modal'

import './style.styl'

const WarningModal = ({ handleCloseModal, handleDisconnect }) => (
  <Modal onClose={handleCloseModal} isOpen style={{ content: { padding: 0, width: 450 }}}>
    <div className="settings-calendar-warning-modal-content">
      <div className="topper">
        <div className="header">Are you sure you want to lift the limit?</div>
        <div className="copy">
          Lifting the limit on sequences means your team will be able to send more emails through their Gmail account, potentially putting your sender score at risk.
        </div>
      </div>
      <div className="controls">
        <button className="tide-button tide-button--tertiary" onClick={handleCloseModal}>
          Cancel
        </button>
        <button className="tide-button tide-button--danger" onClick={handleDisconnect}>
          I Understand
        </button>
      </div>
    </div>
  </Modal>
)

export default WarningModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/advancedConversationSettings/CustomSequenceLimitModal/index.js